import React from 'react';
import { Block } from '@mui/icons-material';
import body1 from "../img/body/body1.png";
import body2 from "../img/body/body2.png";
import body3 from "../img/body/body3.png";
import body4 from "../img/body/body4.png";
import body5 from "../img/body/body5.png";

const Body = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Body positioning and anatomy issues to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-5">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={body1} alt="Body issue example 1" onClick={() => onImageClick && onImageClick(body1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Head on the wrong side
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={body2} alt="Body issue example 2" onClick={() => onImageClick && onImageClick(body2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Impossible anatomy
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={body3} alt="Body issue example 3" onClick={() => onImageClick && onImageClick(body3)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Wrong hand selfie
              </div>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={body4} alt="Body issue example 4" onClick={() => onImageClick && onImageClick(body4)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Body twisted 
              </div>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={body5} alt="Body issue example 5" onClick={() => onImageClick && onImageClick(body5)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Wrong proportions
              </div>
            </div>
          </div>
          
       
        </div>
      </div>
    </>
  );
};

export default Body;